export default function CheckMark({ color = '#002366', width = '14', height = '14' }) {
    return (
        <svg width={width} height={height} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.6663 3.79199L5.24967 10.2087L2.33301 7.29199" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
